import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { LoginService } from './login.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  constructor(
    private loginService: LoginService,
    private uiNotificationService: UINotificationService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          console.log(err);
          this.uiNotificationService.add({
            type: NotificationType.Error,
            message: 'Chyba autentizace'
          });
        }

        //const error = err.error.message || err.statusText;
        return throwError(err);
      }));
  }
}
